import React from "react";
import styles from "./OnboardingStage.module.css";

const PriorityBlocker = ({ title = "Priority Blockers", items = [] }) => {
  const hasItems = Array.isArray(items) && items.length;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>{title}</h3>
      <div className={styles.card}>
        <div className={styles.sectionHeader}>
          <span>!</span>
          <span className={styles.sectionLabel}>Blockers</span>
        </div>
        {hasItems ? (
          items.map((item, index) => (
            <div key={`${item}-${index}`} className={styles.blockerRow}>
              <span className={styles.bulletDot} />
              <span className={styles.blockerText}>{item}</span>
            </div>
          ))
        ) : (
          <div className={styles.emptyState}>
            <span>OK</span>
            <span>None detected; continue the activation cadence.</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PriorityBlocker;
